export default __webpack_public_path__ + "static/media/mobile-phone.7d8eae18.svg";